module.exports = "<div class=\"row\">\r\n  <div class=\"col-xs-12\"></div>\r\n</div>\r\n"